import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import {
    ThemedButton,
    Heading2,
    TextDefault,
    FlexDiv,
    SpaceBetweenDiv,
} from '@awarego-ui/components';
import { useTranslation } from 'react-i18next';

function TrainingViewHeader({
    training,
    subjectsTODO,
    trainingId,
    subjectsDone,
    isExpired,
}) {
    const { t } = useTranslation();

    if (!training) return;

    const buttonText = isExpired
        ? t('Review lessons')
        : subjectsDone.length > 0
        ? t('Resume training')
        : t('Start training');

    const showButton = isExpired || subjectsTODO.length > 0;

    return (
        <SpaceBetweenDiv gap={8} rowGap={16} alignEnd>
            <FlexDiv column gap={8} rowGap={4}>
                <Heading2>{t('Training program')}</Heading2>
                <TextDefault lighter>
                    {training.viewed}/{training.subjectsSent}{' '}
                    {t('videos watched')}
                </TextDefault>
            </FlexDiv>
            {showButton && (
                <Link to={`/trainings/${trainingId}/subjects`}>
                    <ThemedButton
                        mode="primary"
                        text={buttonText}
                    />
                </Link>
            )}
        </SpaceBetweenDiv>
    );
}

export default observer(TrainingViewHeader);
